<template>
  <div class="charge">
    <Loading v-show="loading"></Loading>
    <h1>ログイン</h1>
    <p class="title">メールアドレス</p>
    <input type="email" v-model="mail" placeholder="例）calorie@gmail.com">
    <label>新規登録時に登録したログインID(メールアドレス)</label>
    <button id="login" type="" v-on:click="sendMail()">パスワードを確認する</button>
    <div style="height: 300px"></div>
  </div>
</template>
<style scoped>
*{
  box-sizing: border-box;
}
ul,li{
  margin: 0;
  padding: 0;
  list-style: none;
}
#tab{
  max-width: 40%;
  margin: 16px auto;
}

.tabMenu{
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  list-style: none;
  border-bottom: 1px solid black;
}
#forget{
  color: black;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.tabItem.active{
  background-color: black;
  color: #fff;
}
.key{
  width: 30%;
  background:black;
  color: white;
}
table{
  border-spacing: 0px;
  width: 100%;
  border: 1px solid black;
}
table tr{
  height: 80px;
}
.caution-text{
  font-family: Hiragino Kaku Gothic Pro;
  text-align: center;
}
.value{
  font-size: 24px;
  font-weight: bold;
}
span{
  font-size: 12px;
  font-weight: normal;
  font-family: Hiragino Kaku Gothic Pro;
}
.charge{
  position: relative;
}
#close{
  position: absolute;
  top:0%;
  left:20%;
}
.form .title{
  margin-top: 5%;
  text-align: left;
}
.form input{
  width: 100%;
  padding:8px;
  font-size: 24px;
}
.form label{
 font-size: 12px;
 text-align: left;
 width: 100%;
 display: block;

}
.form table{
  margin-top: 5%;
  margin-bottom: 5%;
}
.bold{
  font-weight: bold;
}
.privacy{
  font-size: 12px;
  color: black;
}
.privacy a{
  color: black;
  text-decoration: underline;
}
#login{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 24px;
  margin:5% auto;
  border:0px;
  width: 100%;
}
@media ( max-width : 600px ){
  h1{
    font-size: 18px;
  }
  #tab{
  max-width: 100%;
  margin: 16px auto;
}
#close{
  position: absolute;
  top:8px;
  left:5%;
  width: 16px;
}
#tab li{
  font-size: 12px;
}
.tabItem{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  flex-basis: 49%;
  flex-shrink: 0;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-top: 1px solid black;
  color: black;
  font-weight: bold;
  text-align: center;
}
.form{
 margin-left: 16px;
 margin-right: 16px;
}
#payButton{
  display: block;
  background:black;
  color: white;
  border-radius: 50px;
  padding-top:8px;
  padding-bottom: 8px;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 14px;
  margin:5% auto;
  border:0px;
}
.form input[data-v-4c82ff2f] {
    width: 100%;
    padding: 8px;
    font-size: 14px;
}
}
formfield {
  float: left;
  width: 100%;
}

label {
  float: left;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6em;
  margin-bottom: 5px;
  color: #92A3A6;
}

input, select, button {
  float: left;
  background: transparent;
  border: 2px solid #EBEBEB;
  border-radius: 3px;
  padding: 5px 10px;
  margin: 0 10px 10px 0;
  font-size: 1.2em;
  line-height: 2em;
  transition: border 300ms ease-in;
}

input:focus, select:focus {
  border-color: #20A8FF;
}

input::-webkit-input-placeholder {
  color: rgba(146,163,166,.5);
}


#ccn input[type="text"] {
  width: calc(25% - 10px);
  letter-spacing: 2px;
  text-align: center;
}

#ch input[type="text"] {
  width: calc(50% - 10px);
  text-align: start;
}

#ed, #sc {
  width: 50%;
}

#sc input[type="text"] {
  width: calc(100% - 10px);
}

#ed select {
  background: #fff;
  height: 46px;
  width: calc(50% - 10px);
  line-height: 2em;
  text-align: center;
  font-size: 14px;
}

#cc {
  width: 50%;
}
</style>
<script>
import $ from 'jquery'
import Loading from '../common/Loading'
import firebase from 'firebase'
export default {
  name: 'Plan',
  components: {
    Loading
  },
  data () {
    return {
      db: null,
      loading: false,
      mail: null,
      mailPattern: /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
    }
  },
  methods: {
    sendMail: function () {
      // メールアドレスの入力確認
      if (!this.mail) {
        alert('メールアドレスの入力をしてからログインボタンを押しましょう')
        return
      }
      let self = this
      self.loading = true
      var data = { 'mail': this.mail}
      $.ajax({
        url: 'https://asia-northeast1-kcal-27d27.cloudfunctions.net/sendMail',
        type: 'GET',
        data: data
      })
        .done(function (data) {
          location.href = '/'
          self.loading = false
        })
        .fail(function () {
          self.loading = false
          alert('アカウント確認のメール送信に失敗しました。再度、実行してください。')
        })
    }
  },
  created: function () {
    this.db = firebase.firestore()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forget/Forget.vue